import { el } from 'redom';

import { stringToSVG } from 'utilities';

import ConditionTypeSelector from '../condition-type-selector';
import CriteriaBuilder from '../criteria-builder';

import deleteIconString from 'assets/images/delete-icon.svg?raw';

const deleteIcon = stringToSVG(deleteIconString);

class ConditionBuilder {

  constructor(options) {

    this.index = options.index;
    this.criteria = options.condition.criteria;
    this.conditionType = options.condition.type;
    this.fieldSelector = options.fieldSelector;
    this.operatorSelector = options.operatorSelector;
    this.onChange = options.onChange;
    this.onRemove = options.onRemove;

    this.defaultCondition = this.index === 0;

    this.conditionTypeSelector = null;
    this.criteriaBuilder = null;
    this.removeButton = null;
    this.firstRow = null;
    this.secondRow = null;

    this.initializeFirstRow();
    this.initializeSecondRow();

    this.el = el('.condition-builder-main', [this.firstRow, this.secondRow]);

  }

  initializeFirstRow() {

    const firstRowChildren = [];

    this.tryInitializeConditionTypeSelector(firstRowChildren);

    this.firstRow = el('.condition-builder-first-row', firstRowChildren);

  }

  initializeSecondRow() {

    const secondRowChildren = [];

    this.initializeCriteriaBuilder(secondRowChildren);
    this.initializeRemoveButton(secondRowChildren);

    this.secondRow = el('.condition-builder-second-row', {
      class: `${secondRowChildren.length}-column`
    }, secondRowChildren);

  }

  tryInitializeConditionTypeSelector(firstRowChildren) {

    if (this.defaultCondition === true) {
      return;
    }

    const options = {
      conditionType: this.conditionType,
      onChange: this.handleConditionTypeChange.bind(this)
    };

    this.conditionTypeSelector = new ConditionTypeSelector(options);

    firstRowChildren.push(this.conditionTypeSelector);

  }

  handleConditionTypeChange(conditionType) {

    this.conditionType = conditionType;

    this.onChange(this.index, {
      type: this.conditionType,
      criteria: this.criteria
    });

  }

  initializeCriteriaBuilder(secondRowChildren) {

    const options = {
      fieldSelector: this.fieldSelector,
      operatorSelector: this.operatorSelector,
      criteria: this.criteria,
      onChange: this.handleCriteriaChange.bind(this)
    };

    this.criteriaBuilder = new CriteriaBuilder(options);

    secondRowChildren.push(this.criteriaBuilder);

  }

  handleCriteriaChange(criteria) {

    this.criteria = criteria;

    this.onChange(this.index, {
      type: this.conditionType,
      criteria: this.criteria
    });

  }

  initializeRemoveButton(secondRowChildren) {

    if (this.defaultCondition === true) {
      return;
    }

    this.removeButton = el('button.remove-condition-builder', {
      onclick: this.handleRemoveButtonClick.bind(this)
    }, [deleteIcon.cloneNode(true)]);

    secondRowChildren.push(this.removeButton);

  }

  handleRemoveButtonClick() {

    this.onRemove(this.index);

  }

  focusInput() {

    this.criteriaBuilder.focusInput();

  }

  updateIndex(newIndex) {

    this.index = newIndex;

  }

}

export default ConditionBuilder;